import { PresentationBundleKind } from '@/types/schema';

import { BundleSaveDescriptor } from '../presentationSave.types';
import { createGeneratedBundleCardDescriptor } from './generatedBundleCardDescriptor';

export const businessOverviewBundleDescriptor: BundleSaveDescriptor =
  createGeneratedBundleCardDescriptor({
    kind: PresentationBundleKind.BusinessOverviewBundle,
    field: 'businessOverviewBundleConfiguration',
    read: (bundle) => {
      const config = bundle.businessOverviewBundleConfiguration;
      if (!config) return undefined;
      return {
        id: config.id,
        displayName: config.displayName,
        itemsPerPage: config.itemsPerPage,
        cards: config.businesses.map((business) => ({
          id: business.id,
          name: business.label,
          items: business.items,
        })),
      };
    },
  });
